import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OsobaZnaJezik } from './osoba-zna-jezik';

@Component({
  selector: 'yt-osoba-zna-jezik-modal-update',
  templateUrl: './osoba-zna-jezik-modal-update.component.html'
})
export class OsobaZnaJezikModalUpdateComponent extends BaseModalUpdateComponent<OsobaZnaJezik> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<OsobaZnaJezik>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) { 
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
